/* Trilogy theme — iLike Agency */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var STORE_KEY = 'trilogy:department';
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function storage(action, value) {
    try {
      if (action === 'get') return window.localStorage.getItem(STORE_KEY) || '';
      if (action === 'set') window.localStorage.setItem(STORE_KEY, value);
    } catch (e) { return ''; }
    return '';
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* ------------------------------------------------------------------
     Header height (used by sticky elements and full-screen heroes)
  ------------------------------------------------------------------ */
  function setHeaderHeight() {
    var header = $('.section-header');
    var ann = $('.section-announcement');
    var h = (header ? header.offsetHeight : 0) + (ann ? ann.offsetHeight : 0);
    document.documentElement.style.setProperty('--header-height', (header ? header.offsetHeight : 0) + 'px');
    document.documentElement.style.setProperty('--header-total', h + 'px');
  }

  /* ------------------------------------------------------------------
     Departments
  ------------------------------------------------------------------ */
  var Department = {
    current: '',

    init: function () {
      var body = document.body;
      var serverDept = body.getAttribute('data-department') || '';
      var pageType = body.getAttribute('data-page-type') || '';
      var remember = body.getAttribute('data-remember-department') === 'true';

      if (serverDept) {
        storage('set', serverDept);
        this.current = serverDept;
        return;
      }
      if (pageType === 'index') {
        this.current = '';
        return;
      }
      var neutral = ['cart', 'search', 'captcha', '404', 'list-collections', 'blog', 'article', 'policy'];
      var isCustomer = pageType.indexOf('customers/') === 0;
      if (remember && (neutral.indexOf(pageType) > -1 || isCustomer)) {
        var stored = storage('get');
        if (stored && $('[data-dept-nav="' + stored + '"]')) {
          this.apply(stored);
        }
      }
    },

    apply: function (key) {
      this.current = key;
      document.body.setAttribute('data-department', key);

      $$('[data-dept-nav]').forEach(function (nav) {
        nav.classList.toggle('is-active', nav.getAttribute('data-dept-nav') === key);
      });
      $$('[data-dept-link]').forEach(function (link) {
        var active = link.getAttribute('data-dept-link') === key;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      if (key) MenuDrawer.selectTab(key);
      Announcement.filter(key);
    }
  };

  /* ------------------------------------------------------------------
     Announcement bar
  ------------------------------------------------------------------ */
  var Announcement = {
    el: null,
    timer: null,
    index: 0,

    init: function () {
      this.el = $('[data-announcement]');
      if (!this.el) return;
      var self = this;
      this.filter(document.body.getAttribute('data-department') || '');
      var prev = $('[data-ann-prev]', this.el);
      var next = $('[data-ann-next]', this.el);
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); self.restart(); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); self.restart(); });
      this.el.addEventListener('mouseenter', function () { self.stop(); });
      this.el.addEventListener('mouseleave', function () { self.restart(); });
      this.el.addEventListener('focusin', function () { self.stop(); });
      this.restart();
    },

    visible: function () {
      if (!this.el) return [];
      return $$('[data-ann-message]', this.el).filter(function (m) { return !m.hasAttribute('data-dept-hidden'); });
    },

    filter: function (key) {
      if (!this.el) return;
      $$('[data-ann-message]', this.el).forEach(function (m) {
        var d = m.getAttribute('data-dept') || '';
        if (d && d !== key) m.setAttribute('data-dept-hidden', '');
        else m.removeAttribute('data-dept-hidden');
        m.classList.remove('is-active');
      });
      var arrows = $$('.announcement__arrow', this.el);
      var count = this.visible().length;
      arrows.forEach(function (a) { a.hidden = count < 2; });
      this.el.hidden = count === 0;
      this.index = 0;
      this.go(0);
    },

    go: function (i) {
      var msgs = this.visible();
      if (!msgs.length) return;
      this.index = (i + msgs.length) % msgs.length;
      $$('[data-ann-message]', this.el).forEach(function (m) { m.classList.remove('is-active'); });
      msgs[this.index].classList.add('is-active');
    },

    stop: function () { clearInterval(this.timer); },

    restart: function () {
      var self = this;
      this.stop();
      if (reduceMotion || this.visible().length < 2) return;
      var speed = parseInt(this.el.getAttribute('data-speed'), 10) || 5000;
      this.timer = setInterval(function () { self.go(self.index + 1); }, speed);
    }
  };

  /* ------------------------------------------------------------------
     Drawers (menu, cart, filters)
  ------------------------------------------------------------------ */
  var Drawer = {
    active: null,
    trigger: null,

    open: function (name, trigger) {
      var drawer = $('[data-drawer="' + name + '"]');
      if (!drawer) return;
      if (this.active && this.active !== drawer) this.close(true);
      this.active = drawer;
      this.trigger = trigger || document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('is-locked');
      if (this.trigger && this.trigger.setAttribute) this.trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
          var focusable = $('.drawer__panel button, .drawer__panel a, .drawer__panel input', drawer);
          if (focusable) focusable.focus({ preventScroll: true });
        });
      });
    },

    close: function (immediate) {
      var drawer = this.active;
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      if (this.trigger && this.trigger.setAttribute) this.trigger.setAttribute('aria-expanded', 'false');
      var trigger = this.trigger;
      this.active = null;
      var finish = function () { drawer.hidden = true; };
      if (immediate || reduceMotion) finish();
      else setTimeout(finish, 350);
      if (trigger && trigger.focus && !immediate) trigger.focus({ preventScroll: true });
    },

    trap: function (e) {
      if (!Drawer.active || e.key !== 'Tab') return;
      var nodes = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', Drawer.active)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  /* ------------------------------------------------------------------
     Mobile menu tabs
  ------------------------------------------------------------------ */
  var MenuDrawer = {
    selectTab: function (key) {
      var tab = $('[data-drawer-tab="' + key + '"]');
      if (!tab) return;
      $$('[data-drawer-tab]').forEach(function (t) {
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        t.setAttribute('tabindex', t === tab ? '0' : '-1');
      });
      $$('[data-drawer-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-drawer-panel') !== key;
      });
    },

    init: function () {
      var self = this;
      var tabs = $$('[data-drawer-tab]');
      tabs.forEach(function (tab, i) {
        tab.setAttribute('tabindex', tab.getAttribute('aria-selected') === 'true' ? '0' : '-1');
        tab.addEventListener('click', function () { self.selectTab(tab.getAttribute('data-drawer-tab')); });
        tab.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          var next = tabs[(i + dir + tabs.length) % tabs.length];
          self.selectTab(next.getAttribute('data-drawer-tab'));
          next.focus();
        });
      });
    }
  };

  /* ------------------------------------------------------------------
     Mega menu (keyboard + touch support; hover handled in CSS)
  ------------------------------------------------------------------ */
  function initMegaMenu() {
    $$('.nav__item--mega').forEach(function (item) {
      var link = $('.nav__link', item);
      item.addEventListener('mouseenter', function () { item.classList.remove('is-closed'); link.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('mouseleave', function () { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); });
      item.addEventListener('focusin', function () { item.classList.remove('is-closed'); link.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }
      });
      link.addEventListener('pointerup', function (e) { item.dataset.pointer = e.pointerType; });
      link.addEventListener('click', function (e) {
        if (item.dataset.pointer === 'touch' && !item.classList.contains('is-open')) {
          e.preventDefault();
          $$('.nav__item--mega.is-open').forEach(function (o) { o.classList.remove('is-open'); });
          item.classList.add('is-open');
        }
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          item.classList.add('is-closed');
          link.setAttribute('aria-expanded', 'false');
          link.focus();
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav__item--mega')) {
        $$('.nav__item--mega.is-open').forEach(function (o) { o.classList.remove('is-open'); });
      }
    });
  }

  /* ------------------------------------------------------------------
     Search overlay + predictive search
  ------------------------------------------------------------------ */
  var Search = {
    el: null,
    trigger: null,
    controller: null,
    timer: null,

    init: function () {
      this.el = $('#SearchOverlay');
      if (!this.el) return;
      var self = this;
      var input = $('[data-predictive-input]', this.el);
      input.addEventListener('input', function () {
        clearTimeout(self.timer);
        self.timer = setTimeout(function () { self.query(input.value.trim()); }, 250);
      });
    },

    open: function (trigger) {
      if (!this.el) return false;
      Drawer.close(true);
      this.trigger = trigger;
      this.el.hidden = false;
      document.body.classList.add('is-locked');
      var input = $('[data-predictive-input]', this.el);
      setTimeout(function () { input.focus(); }, 30);
      return true;
    },

    close: function () {
      if (!this.el || this.el.hidden) return;
      this.el.hidden = true;
      document.body.classList.remove('is-locked');
      if (this.trigger && this.trigger.focus) this.trigger.focus();
    },

    query: function (q) {
      var results = $('[data-predictive-results]', this.el);
      if (q.length < 2) { results.innerHTML = ''; return; }
      if (this.controller) this.controller.abort();
      this.controller = 'AbortController' in window ? new AbortController() : null;
      var url = (theme.routes.predictiveSearch || '/search/suggest') +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[options][prefix]=last' +
        '&section_id=predictive-search';
      fetch(url, this.controller ? { signal: this.controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var content = parseHTML(html).querySelector('[data-predictive-content]');
          results.innerHTML = content ? content.outerHTML : '';
        })
        .catch(function () {});
    }
  };

  /* ------------------------------------------------------------------
     Cart
  ------------------------------------------------------------------ */
  var Cart = {
    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
      });
      $$('[data-cart-count-inline]').forEach(function (el) { el.textContent = count; });
    },

    renderDrawer: function (html) {
      if (!html) return;
      var fresh = parseHTML(html).querySelector('[data-cart-drawer-inner]');
      var current = $('[data-cart-drawer-inner]');
      if (fresh && current) {
        current.replaceWith(fresh);
        this.updateCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
      }
    },

    refresh: function () {
      var self = this;
      return fetch((theme.routes.root || '/') + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) { self.renderDrawer(data['cart-drawer']); });
    },

    change: function (line, quantity) {
      var self = this;
      var inner = $('[data-cart-drawer-inner]');
      if (inner) inner.classList.add('is-loading');
      return fetch((theme.routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer'] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections) self.renderDrawer(data.sections['cart-drawer']);
          else return self.refresh();
        })
        .catch(function () { window.location.href = theme.routes.cart || '/cart'; });
    },

    open: function (trigger) {
      if (theme.cartType !== 'drawer' || document.body.getAttribute('data-page-type') === 'cart') return false;
      if (!$('[data-drawer="cart"]')) return false;
      Search.close();
      Drawer.open('cart', trigger);
      return true;
    }
  };

  /* ------------------------------------------------------------------
     Product page
  ------------------------------------------------------------------ */
  function initProduct(root) {
    var sectionId = root.getAttribute('data-section-id');
    var productUrl = root.getAttribute('data-product-url');
    var picker = $('[data-variant-picker]', root);
    var form = $('[data-product-form]', root);
    var idInput = form ? $('[data-variant-id]', form) : null;
    var addBtn = form ? $('[data-add-button]', form) : null;
    var errorEl = form ? $('[data-form-error]', form) : null;
    var variants = [];

    if (picker) {
      var json = $('[data-variant-json]', picker);
      try { variants = JSON.parse(json.textContent); } catch (e) { variants = []; }
    }

    function selectedOptions() {
      return $$('.variant-picker__option', picker).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
    }

    function markAvailability(options) {
      $$('.variant-picker__option', picker).forEach(function (fs, index) {
        $$('[data-option-input]', fs).forEach(function (input) {
          var test = options.slice();
          test[index] = input.value;
          var available = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) {
              return i === index ? o === input.value : (i < index ? o === test[i] : true);
            });
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !available);
        });
        var sel = $('[data-option-selected]', fs);
        if (sel) sel.textContent = options[index] || '';
      });
    }

    function setButton(variant) {
      if (!addBtn) return;
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = theme.strings.unavailable;
      } else if (!variant.available) {
        addBtn.disabled = true;
        addBtn.textContent = theme.strings.soldOut;
      } else {
        addBtn.disabled = false;
        addBtn.textContent = theme.strings.addToCart;
      }
    }

    function onVariantChange() {
      var options = selectedOptions();
      var variant = findVariant(options);
      markAvailability(options);
      setButton(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (window.history.replaceState) {
        window.history.replaceState({}, '', productUrl + '?variant=' + variant.id);
      }
      if (variant.featured_media) {
        var media = $('[data-media-id="' + variant.featured_media.id + '"]', root);
        var track = $('[data-gallery-track]', root);
        if (media && track) {
          if (window.matchMedia('(min-width: 990px)').matches) {
            if (media !== track.firstElementChild) track.prepend(media);
          } else {
            track.scrollTo({ left: media.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        }
      }
      fetch(productUrl + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var fresh = doc.querySelector('[data-price-container]');
          var current = $('[data-price-container]', root);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }

    if (picker && variants.length) {
      picker.addEventListener('change', onVariantChange);
      markAvailability(selectedOptions());
    }

    $$('[data-qty-input]', root).forEach(function (wrap) {
      var input = $('input', wrap);
      $$('[data-qty-step]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10));
          input.value = next;
        });
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (theme.cartType !== 'drawer' || !$('[data-drawer="cart"]')) return;
        e.preventDefault();
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = theme.strings.adding; }
        if (errorEl) errorEl.hidden = true;
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer');
        fd.append('sections_url', window.location.pathname);
        fetch((theme.routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) {
              if (errorEl) {
                errorEl.textContent = res.data.description || res.data.message || theme.strings.cartError;
                errorEl.hidden = false;
              }
              return;
            }
            if (res.data.sections && res.data.sections['cart-drawer']) Cart.renderDrawer(res.data.sections['cart-drawer']);
            else return Cart.refresh();
          })
          .then(function () {
            if (!errorEl || errorEl.hidden) Drawer.open('cart', addBtn);
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            setButton(variants.length ? findVariant(selectedOptions()) : { available: true });
          });
      });
    }

    var track = $('[data-gallery-track]', root);
    var indexEl = $('[data-gallery-index]', root);
    if (track && indexEl) {
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth) + 1;
        indexEl.textContent = i;
      }, { passive: true });
    }
  }

  /* ------------------------------------------------------------------
     Slideshow
  ------------------------------------------------------------------ */
  function initSlideshow(root) {
    var slides = $$('[data-slide]', root);
    if (slides.length < 2) return;
    var dots = $$('[data-slide-to]', root);
    var index = 0;
    var timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;

    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('a, button', s).forEach(function (el) { el.tabIndex = on ? 0 : -1; });
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === index);
        d.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
    }
    function play() { stop(); if (autoplay) timer = setInterval(function () { go(index + 1); }, speed); }
    function stop() { clearInterval(timer); }

    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide-to'), 10)); play(); }); });
    var prev = $('[data-slide-prev]', root);
    var next = $('[data-slide-next]', root);
    if (prev) prev.addEventListener('click', function () { go(index - 1); play(); });
    if (next) next.addEventListener('click', function () { go(index + 1); play(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);

    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { go(index + (dx < 0 ? 1 : -1)); play(); }
      startX = null;
    });

    go(0);
    play();
  }

  /* ------------------------------------------------------------------
     Product rails and tabs
  ------------------------------------------------------------------ */
  function initRail(root) {
    function activeTrack() {
      return $$('[data-rail-track]', root).filter(function (t) { return t.offsetParent !== null; })[0];
    }
    var prev = $('[data-rail-prev]', root);
    var next = $('[data-rail-next]', root);
    function scrollBy(dir) {
      var track = activeTrack();
      if (!track) return;
      track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
  }

  function initTabs(root) {
    var tabs = $$('[data-tab]', root);
    if (!tabs.length) return;
    var panels = $$('[data-tab-panel]', root);
    function select(i) {
      tabs.forEach(function (t, n) {
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
        t.tabIndex = n === i ? 0 : -1;
      });
      panels.forEach(function (p, n) { p.hidden = n !== i; });
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var n = (i + dir + tabs.length) % tabs.length;
        select(n);
        tabs[n].focus();
      });
    });
    select(0);
  }

  /* ------------------------------------------------------------------
     Recommendations
  ------------------------------------------------------------------ */
  function initRecommendations(root) {
    var url = root.getAttribute('data-url');
    if (!url || $('[data-recommendations-inner]', root)) { initRail(root); return; }
    var load = function () {
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = parseHTML(html).querySelector('[data-recommendations-inner]');
          if (fresh) {
            root.appendChild(fresh);
            initRail(root);
          } else {
            root.hidden = true;
          }
        })
        .catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(root);
    } else {
      load();
    }
  }

  /* ------------------------------------------------------------------
     Global delegated events
  ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var searchOpen = t.closest('[data-search-open]');
    if (searchOpen && Search.open(searchOpen)) { e.preventDefault(); return; }
    if (t.closest('[data-search-close]')) { Search.close(); return; }

    var cartOpen = t.closest('[data-cart-open]');
    if (cartOpen && Cart.open(cartOpen)) { e.preventDefault(); return; }

    var drawerOpen = t.closest('[data-drawer-open]');
    if (drawerOpen) {
      e.preventDefault();
      Drawer.open(drawerOpen.getAttribute('data-drawer-open') || 'menu', drawerOpen);
      return;
    }
    if (t.closest('[data-drawer-close]')) { e.preventDefault(); Drawer.close(); return; }

    var qtyBtn = t.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      Cart.change(parseInt(qtyBtn.getAttribute('data-line'), 10), parseInt(qtyBtn.getAttribute('data-cart-qty'), 10));
      return;
    }

    var recover = t.closest('[data-recover-toggle]');
    if (recover) {
      e.preventDefault();
      var login = $('[data-login-view]');
      var rec = $('[data-recover-view]');
      if (login && rec) {
        var showRecover = rec.hidden;
        rec.hidden = !showRecover;
        login.hidden = showRecover;
      }
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) e.target.form.submit();
  });

  document.addEventListener('submit', function (e) {
    var msg = e.target.getAttribute && e.target.getAttribute('data-confirm');
    if (msg && !window.confirm(msg)) e.preventDefault();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (Search.el && !Search.el.hidden) Search.close();
      else if (Drawer.active) Drawer.close();
    }
    Drawer.trap(e);
  });

  /* ------------------------------------------------------------------
     Boot
  ------------------------------------------------------------------ */
  function boot() {
    MenuDrawer.init();
    Announcement.init();
    Department.init();
    initMegaMenu();
    Search.init();
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight, { passive: true });

    $$('[data-slideshow]').forEach(initSlideshow);
    $$('[data-tabs]').forEach(function (el) { initTabs(el); initRail(el); });
    $$('[data-product]').forEach(initProduct);
    $$('[data-recommendations]').forEach(initRecommendations);

    if (window.location.hash === '#recover') {
      var login = $('[data-login-view]');
      var rec = $('[data-recover-view]');
      if (login && rec) { login.hidden = true; rec.hidden = false; }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Re-initialise sections when edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    $$('[data-slideshow]', t).forEach(initSlideshow);
    $$('[data-tabs]', t).forEach(function (el) { initTabs(el); initRail(el); });
    $$('[data-product]', t).forEach(initProduct);
    $$('[data-recommendations]', t).forEach(initRecommendations);
    if (t.querySelector('[data-announcement]')) Announcement.init();
    if (t.querySelector('[data-header]')) { MenuDrawer.init(); initMegaMenu(); Department.init(); setHeaderHeight(); }
  });
})();
